import { createSlice } from '@reduxjs/toolkit'
import { SegmentListType, ProgramsType, CurrencyType } from '../Shared/types'
import { Month } from 'shared/DateUtils'
import DateUtils from 'shared/DateUtils'
export interface LaunchProgramsState {
  selectedDate: Month | null
  selectedSegments: SegmentListType[]
  selectedPrograms: ProgramsType[]
  programName: string
  description: string
  currency: CurrencyType
  incompleteLaunch: boolean
  isContinued: boolean
  draftState: string | null
}

const INITIAL_STATE: LaunchProgramsState = {
  selectedDate: DateUtils.getNextXMonths(6, 1)[0],
  selectedSegments: [],
  selectedPrograms: [],
  programName: '',
  description: '',
  currency: 'USD',
  incompleteLaunch: false,
  isContinued: false,
  draftState: null,
}

const launchProgramsSlice = createSlice({
  name: 'launchPrograms',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload
    },
    setSelectedSegments: (state, action) => {
      state.selectedSegments = action.payload
    },
    setSelectedPrograms: (state, action) => {
      state.selectedPrograms = action.payload
    },
    setProgramName: (state, action) => {
      state.programName = action.payload
    },
    setDescription: (state, action) => {
      state.description = action.payload
    },
    setCurrency: (state, action) => {
      state.currency = action.payload
    },
    setIncompleteLaunch: (state, action) => {
      state.incompleteLaunch = action.payload
    },
    setDraftProgramState: (state, action) => {
      state.draftState = action.payload
    },
    rehydrateState: (state, action) => {
      state.selectedDate = action.payload.selectedDate
      state.selectedSegments = action.payload.selectedSegments
      state.selectedPrograms = action.payload.selectedPrograms
      state.programName = action.payload.programName || ''
      state.description = action.payload.description || ''
      state.currency = action.payload.currency || 'USD'
      state.incompleteLaunch = false
      state.isContinued = true
      state.draftState = null
    },
    setSateForNewLaunch: (state) => {
      state.selectedDate = DateUtils.getNextXMonths(6, 1)[0]
      state.selectedSegments = []
      state.selectedPrograms = []
      state.programName = ''
      state.description = ''
      state.currency = 'USD'
      state.isContinued = false
    },
  },
})

export const launchProgramsReducer = launchProgramsSlice.reducer
export const launchProgramsReducers = {
  ...launchProgramsSlice.actions,
}
